// eslint-disable-next-line no-unused-vars
import React from 'react';
import { object, func } from 'prop-types';
import { withTranslation } from 'react-i18next';

import ProductPropType from 'Types/product';
import ProductAbstract from 'Containers/ProductAbstract';
import ProductListItemComponent from 'Components/Products/ProductListItem';
import { API_PRODUCTS, PROMOTION_BNDL } from 'Constants';

import withCart from 'AppSrc/hocs/withCart';
import withWishlist from 'AppSrc/hocs/withWishlist';
import withUser from 'AppSrc/hocs/withUser';
import withProducts from 'AppSrc/hocs/withProducts';
import withFetch from 'AppSrc/hocs/withFetch';
import withModals from 'AppSrc/hocs/withModals';
import withToastNotifications from 'AppSrc/hocs/withToastNotifications';

@withProducts
@withFetch
@withUser
@withCart
@withWishlist
@withModals
@withToastNotifications
@withTranslation()
export default class ProductListItem extends ProductAbstract {
  constructor(props) {
    super(props);
    this.handleOnAddToCart = this.handleOnAddToCart.bind(this);
    this.executeAddToCart = this.executeAddToCart.bind(this);
  }

  async handleOnAddToCart(product) {
    const prod = product.id ? product : this.state.product;
    const { modalsContext } = this.props;

    if (!prod.hasPrice) {
      modalsContext.setState(modalsContext.modalState.ADD_EXTERNAL_SUPPLIER_PRODUCT_TO_CART.key, {
        open: true,
        product: prod,
        onConfirm: () => this.executeAddToCart(product)
      });
      return null;
    }

    return this.executeAddToCart(product);
  }

  async executeAddToCart(product) {
    const prod = product.id ? product : this.state.product;
    const { modalsContext, fetch, cart, toast, t, onAddToCart, userContext: { data: { defaultCurrency, withVat } } } = this.props;
    const cartProduct = (cart?.data?.items || []).find(item => {
      if (prod.promotionId) {
        if (
          prod.promotionId === item?.promotion?.promotionId
          && item.promotion.type === PROMOTION_BNDL
        ) {
          return (
            item.productId === prod.id
            || !!item
              .promoItems[prod.promotionId]
              ?.find(promoItem => promoItem.productId === prod.id)
          );
        }
        return (
          prod.id === item.productId
          && prod.promotionId === item?.promotion?.promotionId
        );
      }
      return item.productId === prod.id && item?.supplierId === prod.supplierId && !item.promotion;
    });
    const stockValue = cartProduct
      ? cartProduct.stockValue
      : prod.stockValue;
    const payload = {
      id: cartProduct
        ? cartProduct.productId
        : (prod.id || prod.productId),
      stockValue,
      hasPrice: prod?.hasPrice,
      quantity: (cartProduct?.quantity || 0) + prod.quantity,
      minQuantity: prod.minQuantity,
      ...(!prod.hasPrice && {
        supplierId: prod.supplierId,
        supplierOfferId: prod.supplierOfferId,
      })
    };
    if ((cartProduct?.quantity || 0) + prod.quantity > stockValue) {
      toast.addNotification({
        type: 'warning',
        title: t('products.insufficientStock')
      });
      return null;
    }
    const promotionId = prod.promotionId || prod?.promotion?.promotionId;
    if (promotionId) {
      // if (cartProduct) {
      //   payload.quantity = (cartProduct.quantity / cartProduct.minQuantity)
      //     + (payload.quantity / product.minQuantity);
      // } else {
      //   payload.quantity /= (product.minQuantity || 1);
      // }
      payload.promotion = {
        ...(payload.promotion || {}),
        promotionId
      };
    }
    try {
      if (promotionId) {
        this.setState({ promotionLoading: promotionId });
      } else {
        this.setState({ addToCartLoading: true });
      }
      const [updated, crossProducts] = await Promise.allSettled([
        cart.updateProduct(payload),
        fetch(`${API_PRODUCTS}/${prod.id}/cross-sells?currency=${ defaultCurrency }&vat=${ withVat }`)
      ]);
      if (updated.status === 'fulfilled') {
        if (updated.value === null) {
          toast.addNotification({
            type: 'warning',
            title: t('products.dropShipmentWarning')
          });
        } else {
          if (typeof onAddToCart === 'function') {
            onAddToCart(prod);
          }
          if (!promotionId) {
            this.setState(prevState => ({
              ...prevState,
              shouldUpdate: true,
              product: {
                ...prevState.product,
                quantity: product.minQuantity || 1
              }
            }));
          }
          toast.addNotification({
            title: prod.promotionId
              ? t('cart.successfullyAddedPromotionToCart')
              : t('cart.successfullyAddedToCart')
          });
        }
      } else {
        toast.addNotification({
          type: 'error',
          title: t('cart.failedAddToCart'),
          message: updated.value?.errors?.at(0)?.message
        });
        return null;
      }
      if (
        Array.isArray(crossProducts.value)
        && crossProducts.value.length
      ) {
        modalsContext.setState(modalsContext.modalState.CROSS_SALES.key, {
          open: true,
          products: crossProducts.value,
          product: prod
        });
      }
      return updated.value;
    } catch (err) {
      toast.addNotification({
        type: 'error',
        title: t('cart.failedAddToCart'),
        message: err?.info?.errors?.at(0)?.message
      });
    } finally {
      this.setState({ promotionLoading: false, addToCartLoading: false });
    }
    return null;
  }

  render() {
    const { product, promotionLoading, addToWishlistLoading, addToCartLoading } = this.state;

    return (
      <ProductListItemComponent
        product={ product }
        addToCartLoading={ addToCartLoading }
        addToListLoading={ addToWishlistLoading }
        promotionLoading={ promotionLoading }
        onQuickView={ this.handleOnQuickView }
        onAddToCart={ this.handleOnAddToCart }
        onStockAlertModalOpen={ this.handleStockAlertModalOpen }
        onAddToWishlist={ this.handleOnAddToWishlist }
        onChangeQuantity={ this.handleOnChangeQuantity }
      />
    );
  }
}

ProductListItem.propTypes = {
  wishlists: object,
  modalsContext: object,
  toast: object,
  t: func,
  onAddToCart: func,
  product: ProductPropType,
};
